/**
 * Field key to label mapping for application form fields (Zoho CRM)
 * Used for validation error messages and other user-facing labels
 * Shared across application creation and details editing forms
 */
export const APPLICATION_FIELD_LABELS: { [key: string]: string } = {
	// GENERAL section
	Lead_Source: 'Lead Source',
	Opportunity_Type: 'Rapid Status',
	Owner: 'Owner',
	API_Created_By: 'Created By',
	API_Modified_By: 'Modified By',
	AOB_file: 'AOB file has been created?',
	AOB_required: 'AOB required',
	AOB_full_name: 'AOB full name',

	// PREQUALIFYING section
	Residency_Status: 'Residency Status',
	Employment_Status: 'Employment Type',
	Do_you_earn_at_least_1200_per_month: 'Do you earn at least $1200 per month',
	Payday_loans: 'Do you have any Active Payday loans?',
	Are_you_currently_a_Home_Owner: 'Homeowner',
	Province1: 'Province',
	How_much_do_you_currently_owe_the_CRA: 'How much do you currently owe the CRA',
	If_needed_could_you_find_a_Co_Singer: 'If needed could you find a Co-Signer',
	Bankruptcy_CC_CP: 'Bankruptcy, Credit Counselling, Consumer Proposal',
	Consent_Form_Signed: 'Do you have a LM Credit loan?',
	Payment_Method: 'Payment Method',
	Is_this_a_staffing_agency: 'Is this a staffing agency?',
	MTG_Balance: 'Mortgage Balance',
	Estimated_Value: 'Home Property Value',
	Loan_Det: 'Loan Details',
	Mortgage_Details: 'Mortgage Details',

	// REFERRAL section
	Account_Name: 'Agency',
	Sales_Agent: 'Sales Agent',
	Referred_By: 'Collector',
	Broker: 'Broker',
	Creditt: 'Creditor',
	Referral_type: 'Referral method',
	Creditor_Agency_Name: 'Creditor Details',
	Referral_Date: 'Referral Date',
	Acc_Number: 'Account Number (EDP)',
	Closing_Date: 'Closing Date',
	Account_Bal: 'Account Balance',
	Total_Legal_Fees: 'Total Legal Fees (SAHA)',
	Legal_Fee: 'Legal Fees',
	Agency_Location: 'Agency Location',
	Settlement_Amount: 'Settlement Amount',
	Creditor_Portfolio: 'Creditor Portfolio',
	Additional_Debt2: 'Additional Debt?',
	Loan_Type: 'Loan Type',
	Custom_Settlement: 'Custom Settlement?',
	Loyalty_Payment_Plan: 'Loyalty Program',
	Custom_Agency_Amount: 'Custom Agency Amount',

	// CLIENT section - Personal
	First_Name: 'First Name',
	Middle_Name: 'Middle Name',
	Last_Name: 'Last Name',
	Gender: 'Gender',
	Do_you_have_another_name: 'Do you have another name?',
	Number_of_Dependents: 'Number of dependents',
	Alternative_Name: 'Alternative Name',
	Date_of_Birth: 'Date of Birth',
	Marital_Status: 'Marital Status',
	best_contact_time_range: 'Best contact time',
	best_voe_contact_time_range: 'Best time to contact for VOE',
	S_I_N: 'SIN',
	Last_Contact_Date: 'Last contact date',
	Email1: 'Email',
	Does_you_own_a_car: 'Do you currently own a car?',
	Mobile: 'Best contact number',
	What_is_the_value_of_the_car: 'What is the value of the car?',
	Phone: 'Other contact number',
	No_SIN_Reason: 'No SIN Reason',
	Co_Appl_Required: 'Co-Applicant Required?',

	// CLIENT section - Emergency Contacts (array fields)
	Name1: 'Name',
	Relation_to_Applicant: 'Relationship',
	Phone_Number: 'Phone',

	// CLIENT section - Address
	Address1: 'Address line 1',
	Length_of_Residence: 'Length of Residence',
	Address_Line_2: 'Address Line 2 (Unit number)',
	Monthly_Payments: 'Monthly Payments',
	City: 'City',
	Postal_Code: 'Postal Code',

	// CLIENT section - Employment
	Employer: 'Employer',
	Industry: 'Industry',
	Employment_Status1: 'Employment Status',
	Occupation: 'Occupation',
	Work_Phone: 'Work Phone',
	Pay_Frequency2: 'Pay Frequency',
	Work_Extension: 'Work Extension',
	Income_net_paycheque_income: 'Income (net paycheque income)',
	Length_of_Employment: 'Length of Employment (Month)',
	Last_Pay_Date: 'Last Pay Date',
	Position: 'Position',
	Supervisor_Name: 'Supervisor Name',
	Previous_Employment: 'Previous Employment Section?',
	Next_Pay_Date: 'Next Pay Date',
	Supervisor_Phone_Number: 'Supervisor Phone Number',
	Additional_Employment: 'Additional Employment',

	// CLIENT section - Previous Employment
	Previous_Employment_Type: 'Previous Employment Type',
	Previous_Position: 'Previous Position',
	Previous_Employer: 'Previous Employer',
	Previous_Length_of_Employment: 'Previous Length of Employment (Month)',
	Previous_Supervisor_Name: 'Previous Supervisor Name',
	Previous_Supervisor_Phone_number: 'Previous Supervisor Phone number',
	Previous_Income_net_paycheque_income: 'Previous Income (net paycheque income)',
	Previous_Pay_Frequency: 'Previous Pay Frequency',
	Previous_Payment_Method: 'Previous Payment Method',

	// CLIENT section - Banking
	Financial_Institution_Name: 'Financial Institution Name',
	Financial_Institution_Number: 'Financial Institution Number',
	Bank_Account_Number: 'Bank Account Number',
	Bank_Transit_No: 'Bank Transit Number',
	Branch_Address: 'Branch Address',

	// Additional Debt array fields
	Type_of_Credit: 'Type of Credit',
	Agency: 'Agency',
	Collector: 'Collector',
	misc: 'Creditor',
	Account_Balance: 'Account Balance',
	Account_Number: 'Account Number',

	// CO-APPLICANT section - Personal
	Co_Applicant_Name: 'First Name',
	Guarantor_Name: 'Last Name',
	Co_Applicant_Gender: 'Gender',
	Co_Applicant_Date_of_Birth: 'Date of Birth',
	Email: 'Email',
	Secondary_Cell_Number: 'Best Contact Number',
	Secondary_Home_Number: 'Other Contact Number',
	Secondary_S_I_N: 'SIN',

	// CO-APPLICANT section - Prequalifying
	Co_App_Residency_Status: 'Residency Status',
	Co_App_Employment_Type: 'Employment Status',
	Co_App_BK_CC_CP: 'Bankruptcy, Credit Counselling, Consumer Proposal',

	// CO-APPLICANT section - Address
	Co_Applicant_Property_Address: 'Address line 1',
	Co_Applicant_Address_Line_2_Unit_number: 'Address Line 2 (Unit number)',
	Co_Applicant_City: 'City',
	Co_Applicant_Province: 'Province',
	Co_Applicant_Postal_Code: 'Postal Code',

	// CO-APPLICANT section - Employment
	Co_Applicant_Employer: 'Employer',
	Secondary_Position: 'Position',
	Co_Applicant_Status: 'Employment Status',
	Secondary_Work_Number: 'Work Phone',
	Secondary_Years_Worked: 'Length of Employment (Month)',
	Co_Applicant_Pay_Frequency: 'Pay Frequency',
	Sec_Annual_Income: 'Annual Income',

	// CO-APPLICANT section - Banking
	Co_Applicant_Financial_Institution_Name: 'Financial Institution Name',
	Co_ApplicantFinancial_Institution_Number1: 'Financial Institution Number',
	Co_Applicant_Bank_Account: 'Bank Account Number',
	Co_Applicant_Bank_Transit_No: 'Bank Transit Number',
	Co_Applicant_Branch_Address: 'Branch Address',

	// CO-APPLICANT section - Emergency Contact
	Co_Applicant_emergency_contact_name: 'Emergency Contact Name',
	Co_Applicant_emergency_contact_relation: 'Emergency Contact Relationship',
	Co_Applicant_Emergency_contact_number2: 'Emergency Contact Number',

	// Computed fields (local-only)
	_employmentYears: 'Employment Years',
	_employmentMonths: 'Employment Months',
	_coApplicantEmploymentYears: 'Co-Applicant Employment Years',
	_coApplicantEmploymentMonths: 'Co-Applicant Employment Months',
};